import { isKyolook } from 'constants/domains/domains';

const CDN = 'https://cdn.nmodelin.com';
const WEB_VIEW_URL = isKyolook() ? 'https://webview.kyolook.com' : 'https://webview.nmodelin.com';

const URLS = {
  WEB_VIEW: {
    // URL: 'http://localhost:3000',
    URL: WEB_VIEW_URL,
  },
  CDN: {
    URL: CDN,
    COMMON: {
      URL: `${CDN}/common`,
      IMAGES: {
        URL: `${CDN}/common/images`,
        GUIDELINES: {
          URL: `${CDN}/common/images/guidelines`,
          EMBLEMS: {
            URL: `${CDN}/common/images/guidelines/emblems`,
            OLIVEYOUNG_SALE: {
              URL: `${CDN}/common/images/guidelines/emblems/oliveyoung-sale`,
            },
          },
        },
      },
    },
    BRAND: {
      URL: `${CDN}/brand`,
      DOCUMENTS: {
        URL: `${CDN}/brand/documents`,
      },
      IMAGES: {
        URL: `${CDN}/brand/images`,
        BANNERS: {
          URL: `${CDN}/brand/images/banners`,
        },
      },
      VIDEOS: {
        URL: `${CDN}/brand/videos`,
        AUTH: {
          URL: `${CDN}/brand/videos/auth`,
        },
      },
    },
  },
};

export default URLS;
